import SingleFetchConsumer from './SingleFetchConsumer.js';

/**
 * @module Grid/feature/export/consumer/PrintConsumer
 */

/**
 * This consumer stores all generated pages in a local array and renders them in an iframe to call browser print.
 *
 * @extends Grid/feature/export/consumer/SingleFetchConsumer
 * @internal
 */
export default class PrintConsumer extends SingleFetchConsumer {
    async finalize() {
        await this.feature.doPrint(this.pages);

        this.pages.length = 0;

        return {};
    }
}
